import React from 'react';
import {debounceWaitTime} from '../constants/configs';
import pDebounce from 'p-debounce';

const ReactTableTextFilter = ({onChange, filter, style = null}) => {
  const onChangeInput = pDebounce(onChange, debounceWaitTime);
  return (
    <input
      defaultValue={filter && filter.value ? filter.value : undefined}
      onChange={e => onChangeInput(e.target.value)}
      style={{width: '100%', alignSelf: 'flex-end', ...style}}
    />
  );
};

export default ReactTableTextFilter;